import {css} from 'styled-components'

export default css`
position: relative;
padding-left: 1rem;
padding-right: 1rem;
text-align: center;

.person {
  position: relative;
  z-index: 1;
  width: 100%;
  margin-bottom: 90px / -2;

  img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
  }
}

.quoteText {
  border-radius: 5px;

  position: relative;
  padding: 3rem;
  background-color: #f0f0f0;

  > .markdown p {
    font-size: 1.5rem;
    font-weight: 300;
    font-family: 'Space Grotesk', sans-serif;
    color: #001f23;
    line-height: 2rem;

    margin-bottom: 0.5rem;
  }

  .name {
    font-family: 'Space Grotesk', sans-serif;
    font-size: 1.5rem;

    font-weight: 700;
  }

  &::before,
  &::after {
    font-family: 'Space Grotesk', 'Space Grotesk', sans-serif;
    font-size: 3.5rem;

    position: absolute;
  }

  &::before {
    content: '“';
    top: 2.5rem;
    left: -1rem;
  }

  &::after {
    content: '”';
    bottom: 1.5rem;
    right: -1rem;
  }
}

.arrow {
  display: none;
}
`